import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { AddFundsButton, Heading, HeroNoSpacing, MainContainer, SecondaryText } from '../common.js';
import { useModalStore } from '../../stores/index.js';
import { useMemo } from 'react';
import { CpslButton } from '@usecapsule/react-components';
import { ModalStep } from '../../utils/steps.js';
export const AddFundsDone = ({ isSuccess, onClose }) => {
    const setStep = useModalStore(state => state.setStep);
    const onRampPurchase = useModalStore(state => state.onRampPurchase);
    const formatter = useMemo(() => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: onRampPurchase.fiatCurrency || 'USD',
        });
    }, [onRampPurchase.fiatCurrency]);
    const [hero, heading, text, buttons] = isSuccess
        ? [
            _jsx(SuccessIcon, { icon: "check" }),
            _jsx(SuccessHeading, { children: "Funds Added" }),
            onRampPurchase.fiatCurrency ? (_jsxs(SecondaryText, { children: [formatter.format(parseFloat(onRampPurchase.fiatQuantity)), " has been added to your wallet."] })) : null,
            _jsxs(_Fragment, { children: [_jsx(CpslButton, { fullWidth: true, onClick: onClose, children: "Done" }), _jsx(AddFundsButton, { text: "Add More Funds" })] }),
        ]
        : [
            _jsx(FailureIcon, { icon: "alertCircle" }),
            _jsx(FailureHeading, { children: "Something Went Wrong" }),
            _jsx(SecondaryText, { children: "No funds were added to your wallet." }),
            _jsx(CpslButton, { fullWidth: true, onClick: () => {
                    setStep(ModalStep.ADD_FUNDS);
                }, children: "Try Again" }),
        ];
    return (_jsxs(_Fragment, { children: [hero, _jsxs(MainContainer, { children: [heading, text] }), buttons] }));
};
const SuccessIcon = styled(HeroNoSpacing) `
  --icon-color: #34a853;
  --icon-fill-color: #34a853;
  --icon-stroke-color: #34a853;

  svg {
    stroke: #34a853;
  }
`;
const FailureIcon = styled(HeroNoSpacing) `
  --icon-color: #f04438;
  --icon-fill-color: #f04438;
  --icon-stroke-color: #f04438;

  svg {
    stroke: #f04438;
  }
`;
const SuccessHeading = styled(Heading) `
  color: #34a853;
`;
const FailureHeading = styled(Heading) `
  color: #f04438;
`;
